module.exports = __webpack_public_path__ + "img/help-hexagon.65214210.svg";